<template>
  <div class="panel-components-hidden-elements" v-show="this.show">

    <div class="he-heading">
      <h5>{{ $t(`ct-font-group-site`)}}</h5>

      <div class="w-100 pt-4">
        <button class="btn btn-dark d-block" @click="uploadFontUser">
          <i class="svg-icon svgi-add-font"></i>
          {{$t('ct-upload-font')}}
        </button>
        <a href="#" @click.prevent="manageFontUpload" class="d-block">{{$t('ct-manage-user-font')}}</a>
      </div>
    </div>

    <div class="buttons-place">
      <div v-for="(font, index) in fontGroupEdition" :key="index">
        <button class="button-go-to" @click="goTo(index)">{{$t('ct-title-'+index)}}</button>
      </div>
    </div>

    <div id="accordionPageFont">
      <div v-for="(font, index) in fontGroupEdition" :key="index" class="card place-font-style-group">

        <h5 class="mb-0 ellipsis dropdown-arrow blue-header" :id="'font-group-index-'+index">
          {{$t('ct-title-'+index)}}
        </h5>
        <div>
          <div class="card-body font-item-group p-0 mt-2 mb-0">

            <h1 class="element-preview-font-group mb-4" v-show="index === 'h1'">{{defaultText}}</h1>
            <h2 class="element-preview-font-group mb-4" v-show="index === 'h2'">{{defaultText}}</h2>
            <h3 class="element-preview-font-group mb-4" v-show="index === 'h3'">{{defaultText}}</h3>
            <h4 class="element-preview-font-group mb-4" v-show="index === 'h4'">{{defaultText}}</h4>
            <h5 class="element-preview-font-group mb-4" v-show="index === 'h5'">{{defaultText}}</h5>
            <h6 class="element-preview-font-group mb-4" v-show="index === 'h6'">{{defaultText}}</h6>
            <p class="element-preview-font-group mb-4" v-show="index === 'p'">{{defaultText}}</p>

            <div v-for="(item) in Object.keys(font)">
              <template v-if="item === 'family'" class="font-item ">
                <div class="w-100 mb-4">
                  <label class="w-100 ">
                    {{ $t('ct-font-family')}}

                    <v-select :options="options" :get-option-label="getLabel" label="text"
                              @input="valueFont =>setSelected(index, valueFont)" :value="fontGroupEdition[index][item]"
                              class="font w-100"
                              v-model="fontGroupEdition[index][item]">
                      <template slot="option" slot-scope="option">
                        <span :style="'font-family:'+ option.value +' !important;'">{{ option.text }}</span>
                      </template>
                    </v-select>

                  </label>
                </div>
              </template>
              <template v-if="item === 'size'">
                <div class="w-100 mb-4">
                  <label class="w-100">
                    {{ $t('ct-font-size')}}
                  </label>
                  <div style="display: flex" class="font-item-content">
                    <small class="small-legend pos-left">10px</small>
                    <small class="small-legend pos-right">120px</small>
                    <input type="range" class="custom-range" min="10" max="120" step="1"
                           :value="parseInt(fontGroupEdition[index][item])"
                           v-tooltip="{content:parseInt(fontGroupEdition[index][item])+'px',  class: 'tooltip-custom'}"
                           @change="changeFont($event, index, 'size')"
                           @mousemove="changeFont($event, index, 'size')" style="margin-top: 10px;width: 65%;">
                    <input type="number" class="form-control" style="width: 25%; margin-left: 5px" min="10" max="120"
                           :value="parseInt(fontGroupEdition[index][item])"
                           @change="changeFont($event, index, 'size')">
                    <span style="width: 10%;padding-top: 10px;padding-left: 5px;font-size: 15px;">px</span>
                  </div>
                </div>
              </template>
              <template v-if="item === 'sizeMobile'">
                <div class="w-100 mb-4">
                  <label>
                    {{ $t('ct-font-size-mobile')}}
                  </label>
                  <div style="display: flex" class="font-item-content">
                    <small class="small-legend pos-left">10px</small>
                    <small class="small-legend pos-right">120px</small>
                    <input type="range" class="custom-range" min="10" max="120" step="1"
                           :value="parseInt(fontGroupEdition[index][item])"
                           v-tooltip="{content:parseInt(fontGroupEdition[index][item])+'px',  class: 'tooltip-custom'}"
                           @change="changeFont($event, index, 'sizeMobile')"
                           @mousemove="changeFont($event, index, 'sizeMobile')" style="margin-top: 10px;width: 65%;">
                    <input type="number" class="form-control" style="width: 25%; margin-left: 5px" min="10" max="120"
                           :value="parseInt(fontGroupEdition[index][item])"
                           @change="changeFont($event, index, 'sizeMobile')">
                    <span style="width: 10%;padding-top: 10px;padding-left: 5px;font-size: 15px;">px</span>
                  </div>
                </div>
              </template>
              <template v-if="item === 'line-height'">
                <div class="w-100 mb-4">
                  <label>
                    {{ $t('ct-line-height')}}
                  </label>
                  <div style="display: flex" class="font-item-content">
                    <small class="small-legend pos-left">0em</small>
                    <small class="small-legend pos-right">30em</small>
                    <input type="range" class="custom-range" min="0" max="30" step="0.1"
                           :value="parseFloat(fontGroupEdition[index][item])"
                           v-tooltip="{content:parseFloat(fontGroupEdition[index][item])+'em',  class: 'tooltip-custom'}"
                           @change="changeFont($event, index, 'line-height')"
                           @mousemove="changeFont($event, index, 'line-height')" style="margin-top: 10px;width: 65%;">
                    <input type="number" class="form-control" style="width: 25%; margin-left: 5px" min="0" max="10"
                           step="0.1"
                           :value="parseFloat(fontGroupEdition[index][item])"
                           @change="changeFont($event, index, 'line-height')">
                    <span style="width: 10%;padding-top: 10px;padding-left: 5px;font-size: 15px;">em</span>
                  </div>
                </div>
              </template>
              <template v-if="item === 'color'">
                <label class="w-100 mb-4">
                  {{ $t('ct-color')}}
                  <color-picker-component ref="fontColor" :id="index"></color-picker-component>
                </label>
              </template>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import ColorPickerComponent from "../../resources/Abstract/ColorPicker"

  export default {
    name: 'fontGroupEdition',
    components: {
      ColorPickerComponent
    },
    data() {
      return {
        show: false,
        defaultText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla euismod dui justo, vitae molestie risus tempus eget. Etiam ac tristique nisl, vel eleifend tortor.',
        options: [
          {text: "Abuget", value: "abuget"},
          {text: "Adella", value: "adella"},
          {text: "Advantage", value: "advantage"},
          {text: "Amatic", value: "amatic"},
          {text: "Andale Mono", value: "andale mono, times"},
          {text: "Anton", value: "anton"},
          {text: "Arial", value: "arial, helvetica, sans-serif"},
          {text: "Arial Black", value: "arial black, avant garde"},
          {text: "Artega", value: "artega"},
          {text: "Assistant", value: "assistant"},
          {text: "Assistant Bold", value: "assistant bold"},
          {text: "Assistant Light", value: "assistant light"},
          {text: "Assistant Semibold", value: "assistant semibold"},
          {text: "Autobus", value: "autobus"},
          {text: "Barlow Extra Light", value: "barlow extra light"},
          {text: "Barlow Medium", value: "barlow medium"},
          {text: "Basic", value: "basic"},
          {text: "Bebas Neue", value: "bebas neue"},
          {text: "Best Week", value: "best week"},
          {text: "Book Antiqua", value: "book antiqua, palatino"},
          {text: "Breathe", value: "breathe"},
          {text: "Bree Serif", value: "bree serif"},
          {text: "Caudex", value: "caudex"},
          {text: "Caveat", value: "caveat"},
          {text: "Caveat Bold", value: "caveat bold"},
          {text: "Charrie", value: "charrie"},
          {text: "Chelsea Market", value: "chelsea market"},
          {text: "Cinzel", value: "cinzel"},
          {text: "Cinzel Semibold", value: "cinzel semibold"},
          {text: "Comic Sans MS", value: "comic sans ms, sans-serif"},
          {text: "Cookie", value: "cookie"},
          {text: "Coolvetica", value: "coolvetica"},
          {text: "Corben", value: "corben"},
          {text: "Cormorant Garamond Light", value: "cormorant garamond light"},
          {text: "Cormorant Garamond Semibold", value: "cormorant garamond semibold"},
          {text: "Courier New", value: "courier new, courier"},
          {text: "Courier New", value: "courier new"},
          {text: "Curve Bold", value: "curve bold"},
          {text: "Curve Regular", value: "curve regular"},
          {text: "Curve Slim", value: "curve slim"},
          {text: "Damion", value: "damion"},
          {text: "Dancing Script", value: "dancing script"},
          {text: "EB Garamond", value: "eb garamond"},
          {text: "EB Garamond Extrabold", value: "eb garamond extrabold"},
          {text: "Enriqueta", value: "enriqueta"},
          {text: "Enriqueta Bold", value: "enriqueta bold"},
          {text: "Enriqueta Medium", value: "enriqueta medium"},
          {text: "Enriqueta Semibold", value: "enriqueta semibold"},
          {text: "Exquite", value: "exquite"},
          {text: "Fahkwang", value: "fahkwang"},
          {text: "Fahkwang Medium", value: "fahkwang medium"},
          {text: "Feeling", value: "feeling"},
          {text: "Forum", value: "forum"},
          {text: "Frank Ruhl Libre", value: "frank ruhl libre"},
          {text: "Frank Ruhl Libre Bold", value: "frank ruhl libre bold"},
          {text: "Fraunces Bold", value: "fraunces bold"},
          {text: "Fraunces Light", value: "fraunces light"},
          {text: "Fraunces Thin", value: "fraunces thin"},
          {text: "Fredericka the Great", value: "fredericka the great"},
          {text: "Geist", value: "geist"},
          {text: "Geist Bold", value: "geist bold"},
          {text: "Geist Light", value: "geist light"},
          {text: "Geist Thin", value: "geist thin"},
          {text: "Georgia", value: "georgia, palatino"},
          {text: "Georgia Estate", value: "georgia estate"},
          {text: "Harshita", value: "harshita"},
          {text: "Heebo", value: "heebo"},
          {text: "Heebo Black", value: "heebo black"},
          {text: "Heebo Bold", value: "heebo bold"},
          {text: "Heebo Extralight", value: "heebo extralight"},
          {text: "Heebo Semibold", value: "heebo semibold"},
          {text: "Hell Deco", value: "hell deco"},
          {text: "Helsinki", value: "helsinki"},
          {text: "Helvetica", value: "helvetica"},
          {text: "Impact", value: "impact, chicago"},
          {text: "Jockey One", value: "jockey one"},
          {text: "Josefin Slab", value: "josefin slab"},
          {text: "Josefin Slab Bold", value: "josefin slab bold"},
          {text: "Jura", value: "jura"},
          {text: "Jura Bold", value: "jura bold"},
          {text: "Karantina", value: "karantina"},
          {text: "Karantina Light", value: "karantina light"},
          {text: "Kelly Slab", value: "kelly slab"},
          {text: "La Lemonti", value: "la lemonti"},
          {text: "La Lemonti Italic", value: "la lemonti italic"},
          {text: "Laisha", value: "laisha"},
          {text: "Lato", value: "Lato, sans-serif"},
          {text: "Lato Black", value: "Lato Black, sans-serif"},
          {text: "Lato Bold", value: "lato bold"},
          {text: "Lato Italic", value: "lato italic"},
          {text: "Lato Light", value: "Lato Light, sans-serif"},
          {text: "Lato Thin", value: "Lato Thin, sans-serif"},
          {text: "Lavener", value: "lavener"},
          {text: "Lexa", value: "lexa"},
          {text: "Lobster", value: "lobster"},
          {text: "Marck Script", value: "marck script"},
          {text: "Marmelad", value: "marmelad"},
          {text: "Monofonto", value: "monofonto"},
          {text: "Monoton", value: "monoton"},
          {text: "Montserrat", value: "Montserrat, sans-serif"},
          {text: "Montserrat Light", value: "Montserrat Light, sans-serif"},
          {text: "Montserrat Semi Bold", value: "Montserrat Semi Bold, sans-serif"},
          {text: "Mr De Haviland", value: "mr de haviland"},
          {text: "Muli", value: "Muli, sans-serif"},
          {text: "Muli Black", value: "Muli Black, sans-serif"},
          {text: "Muli Bold", value: "muli bold"},
          {text: "Muli Bold Italic", value: "muli bold italic"},
          {text: "Muli Italic", value: "muli italic"},
          {text: "Muli Light", value: "Muli Light, sans-serif"},
          {text: "Muli Semibold", value: "muli semibold"},
          {text: "Mutua", value: "mutua"},
          {text: "Niconne", value: "niconne"},
          {text: "Nobile", value: "nobile"},
          {text: "Nobile Bold", value: "nobile bold"},
          {text: "Noticia Text", value: "noticia text"},
          {text: "Nunito", value: "Nunito, sans-serif"},
          {text: "Open Sans", value: "Open Sans, helvetica, sans-serif"},
          {text: "Open Sans Bold", value: "open sans bold"},
          {text: "Oswald", value: "oswald"},
          {text: "Oswald Bold", value: "oswald bold"},
          {text: "Oswald Extralight", value: "oswald extralight"},
          {text: "Oswald Medium", value: "oswald medium"},
          {text: "Ottmar Hollington", value: "ottmar hollington"},
          {text: "Overlock", value: "overlock"},
          {text: "Patrick Hand", value: "patrick hand"},
          {text: "Play", value: "play"},
          {text: "Play Bold", value: "play bold"},
          {text: "Playfair Display", value: "Playfair Display, sans-serif"},
          {text: "Playfair Display Black", value: "playfair display black"},
          {text: "Playfair Display Black Italic", value: "playfair display black italic"},
          {text: "Playfair Display Bold", value: "playfair display bold"},
          {text: "Playfair Display Bold Italic", value: "playfair display bold italic"},
          {text: "Poppins", value: "poppins"},
          {text: "Poppins Bold", value: "poppins bold"},
          {text: "Poppins Bold Italic", value: "poppins bold italic"},
          {text: "Poppins Extralight", value: "poppins extralight"},
          {text: "Poppins Extralight Italic", value: "poppins extralight italic"},
          {text: "Poppins Italic", value: "poppins italic"},
          {text: "Poppins Semibold", value: "poppins semibold"},
          {text: "Poppins Semibold Italic", value: "poppins semibold italic"},
          {text: "Quicksand", value: "quicksand"},
          {text: "Quicksand Bold", value: "quicksand bold"},
          {text: "Quicksand Medium", value: "quicksand medium"},
          {text: "Quicksand Semibold", value: "quicksand semibold"},
          {text: "Raleway Bold", value: "raleway bold"},
          {text: "Raleway Bold Italic", value: "raleway bold italic"},
          {text: "Raleway Semibold", value: "raleway semibold"},
          {text: "Raleway Semibold Italic", value: "raleway semibold italic"},
          {text: "Roboto", value: "Roboto, sans-serif"},
          {text: "Roboto Black", value: "roboto black"},
          {text: "Roboto Black Italic", value: "roboto black italic"},
          {text: "Roboto Bold", value: "roboto bold"},
          {text: "Roboto Bold Italic", value: "roboto bold italic"},
          {text: "Roboto Italic", value: "roboto italic"},
          {text: "Roboto Light", value: "roboto light"},
          {text: "Roboto Light Italic", value: "roboto light italic"},
          {text: "Rozha One", value: "rozha one"},
          {text: "Rubik", value: "rubik"},
          {text: "Rubik Bold", value: "rubik bold"},
          {text: "Rubik Light", value: "rubik light"},
          {text: "Rubik Medium", value: "rubik medium"},
          {text: "Sacramento", value: "sacramento"},
          {text: "Sail", value: "sail"},
          {text: "Sarina", value: "sarina"},
          {text: "Seaside Resort", value: "seaside resort"},
          {text: "Space Grotesk", value: "space grotesk"},
          {text: "Space Grotesk Bold", value: "space grotesk bold"},
          {text: "Still Time", value: "still time"},
          {text: "Summer Pisces", value: "summer pisces"},
          {text: "Symbol", value: "symbol"},
          {text: "Syne", value: "syne"},
          {text: "Syne Bold", value: "syne bold"},
          {text: "Tahoma", value: "tahoma, arial, helvetica, sans-serif"},
          {text: "Terminal", value: "terminal, monaco"},
          {text: "Thirsty Caps", value: "thirsty caps"},
          {text: "Timeburner ", value: "timeburner"},
          {text: "Timeburner Bold", value: "timeburner bold"},
          {text: "Times New Roman", value: "times new roman, times"},
          {text: "Trebuchet MS", value: "trebuchet ms, geneva"},
          {text: "Verdana", value: "verdana, geneva"},
          {text: "Want Coffee", value: "want coffee"},
          {text: "Webdings", value: "webdings"},
          {text: "Wingdings", value: "wingdings, zapf dingbats"},
          {text: "Work Sans", value: "work sans"},
          {text: "Work Sans Bold", value: "work sans bold"},
          {text: "Work Sans Light", value: "work sans light"},
          {text: "Work Sans Medium", value: "work sans medium"},
          {text: "Yukita Black", value: "yukita black"},
          {text: "Yukita Bold", value: "yukita bold"},
          {text: "Yukita Extrabold", value: "yukita extrabold"},
          {text: "Yukita Light", value: "yukita light"},
          {text: "Yukita Medium", value: "yukita medium"},
          {text: "Yukita Regular", value: "yukita regular"},
          {text: "Yukita Semibold", value: "yukita semibold"}
        ]
      }
    },
    props: {
      fontGroupEdition: {},
      fontList: {},
    },
    methods: {
      goTo(index){
        document.getElementById('font-group-index-'+index).scrollIntoView({  behavior: 'smooth' });
      },
      showPanel() {
        this.show = !this.show;
        return this.show;
      },
      setSelected(where, dataFont) {
        this.$root.$emit('changeFontGroup', where, 'family', dataFont.value);
        this.$nextTick(() => {
          $('#pageFont').trigger('click')
        })
      },
      uploadFontUser() {
        this.$root.$emit('fontUpload');
      },
      manageFontUpload() {
        this.$root.$emit('manageFontUpload', this.options);
      },
      changeFont(e, font, type) {
        this.$root.$emit('changeFontGroup', font, type, e.target.value);
      },
      getLabel: function (val) {
        if (typeof val === 'object') {
          return val.text;
        } else {

          let text = this.options.filter(function (option) {
            return option.value === val;
          });

          if (typeof text !== 'undefined' && typeof text[0] !== 'undefined')
            return text[0].text;

          return '';
        }
      },
      setFontGroup() {
        this.$refs.fontColor.forEach(ref => {
          let obj = {
            defaultValue: this.fontGroupEdition[ref.$attrs.id].color,
            callback: (value) => {
              this.$root.$emit('changeFontGroup', ref.$attrs.id, 'color', value);
            }
          };
          ref.setValues(obj);
        });
      },
      hidePanel() {
        let vm = this;
        vm.show = false;
      }
    },
    mounted() {
      let vm = this;

      this.$root.$on('addFonts', (params) => {
        vm.options.push(params);

        vm.options.sort((a, b) => (a.text > b.text) ? 1 : -1)

        this.$root.$emit('setFontStyleFonts', vm.options);
      });

      this.$root.$on('deleteFonts', (font_value) => {
        let options = vm.options.filter(font => {
          return font.value !== font_value
        });

        options.sort((a, b) => (a.text > b.text) ? 1 : -1);

        vm.options = [];
        vm.options = options;
        this.$root.$emit('setFontStyleFonts', options);
      });

      this.$root.$on('showFontGroupBar', function () {
        vm.show = !vm.show;
        vm.setFontGroup();
      });

      this.$emit('default-font-options', vm.options);
    }
  }
</script>
<style lang="scss" scoped>

  .font-item {
    display: inline-block;
    width: 100%;

    label {
      margin-bottom: 0;
      margin-top: 15px;
    }
  }

  .font-item-group {
    border: none;

    .element-preview-font-group {
      overflow: hidden !important;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      max-width: 350px;
      padding: 10px;
      border: 1px solid lightgray;
      border-radius: 5px;
      overflow: hidden;
    }
  }

  .place-font-style-group:not(:last-of-type){
    border-bottom: 1px solid lightgray !important;
    border-radius: 0;
  }

  #accordionPageFont {
    overflow-y: scroll;
    max-height: 500px;
    padding: 0 30px 30px;

    .blue-header {
      color: blue;
      font-weight: bold;
      margin-top: 20px;
    }
  }

  .font-item-content {
    position: relative;

    small.small-legend {
      position: absolute;
      top: -5px;
      font-size: 10px;

      &.pos-right {
        right: 85px;
      }
    }
  }

  .buttons-place{
    left: -107px;
    position: absolute;
    top: 150px;
  }

  .button-go-to{
    box-shadow: -2px 0px 3px 0px #d5d5d5;
    background-color: white;
    color: black;
    border: none;
    padding: 5px;
    margin: 5px;
    max-width: 100px;
    width: 100px;
    border-radius: 5px 0 0 5px;

    &:hover{
      cursor: pointer;
      color: white;
      background-color: #007ffc;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/editor/base/sidebar/FontGroupEdition.vue